import { GeoJSONSource } from 'maplibre-gl';
import { useRef } from 'react';
export function useSource(map, id) {
  const featureCollection = useRef(null);
  function addGeoJSONSource(collection = {
    type: 'FeatureCollection',
    features: []
  }, options) {
    if (!map) return;
    const source = getGeoJSONSource();
    if (source) {
      updateGeoJSONSource(collection);
      return;
    }
    map.addSource(id, {
      type: 'geojson',
      data: collection,
      ...(options || {})
    });
  }
  function getGeoJSONSource() {
    const source = map?.style && map?.getSource(id);
    return source && source instanceof GeoJSONSource ? source : null;
  }
  function updateGeoJSONSource(collection) {
    const source = getGeoJSONSource();
    if (source) {
      source.setData(collection);
      if (typeof collection === 'object') featureCollection.current = {
        ...collection
      };
    }
  }
  function clearGeoJSONSource() {
    updateGeoJSONSource({
      type: 'FeatureCollection',
      features: []
    });
  }
  return {
    featureCollection,
    addGeoJSONSource,
    getGeoJSONSource,
    updateGeoJSONSource,
    clearGeoJSONSource
  };
}